import { makeVar, useReactiveVar } from '@apollo/client';

import {
  InquisitiveCurriculum,
  InquisitiveCurriculumVersions,
  InquisitiveSubject,
  InquisitiveYears,
} from 'global/graphql/scalars.type';
import { VIEW_LESSONS, ViewMode } from './filters.constants';

export type ContentFilters = {
  curriculumFilter: InquisitiveCurriculum[] | null;
  curriculumVersionFilter: InquisitiveCurriculumVersions[] | null;
  subjectFilter: InquisitiveSubject[] | null;
  yearFilter: InquisitiveYears[] | null;
  readPreferenceFilter: boolean;
  triggerContentRefresh: boolean;
};

const contentFiltersVar = makeVar<ContentFilters>({
  curriculumFilter: null,
  curriculumVersionFilter: null,
  subjectFilter: null,
  yearFilter: null,
  readPreferenceFilter: true,
  triggerContentRefresh: false,
});

export function setReadPreferenceFilter(state: boolean) {
  contentFiltersVar({
    ...contentFiltersVar(),
    ...{
      readPreferenceFilter: state,
    },
  });
}

export function setTriggerContentRefresh(state: boolean) {
  contentFiltersVar({
    ...contentFiltersVar(),
    ...{
      triggerContentRefresh: state,
    },
  });
}

export function setContentFilterData(properties: Partial<ContentFilters>) {
  const currentValues = contentFiltersVar();
  let data = {
    ...currentValues,
    ...properties,
  };

  if (
    properties.curriculumFilter ||
    properties.curriculumVersionFilter ||
    properties.yearFilter ||
    properties.subjectFilter
  ) {
    data = {
      ...data,
      curriculumFilter:
        properties.curriculumFilter || currentValues.curriculumFilter,
      curriculumVersionFilter:
        properties.curriculumVersionFilter ||
        currentValues.curriculumVersionFilter,
      yearFilter: properties.yearFilter || currentValues.yearFilter,
      subjectFilter: properties.subjectFilter || currentValues.subjectFilter,
    };
  }

  contentFiltersVar(data);
  return data;
}

export function getContentFilters() {
  return contentFiltersVar();
}

export const useContentFilters = () => {
  return useReactiveVar(contentFiltersVar);
};

const viewModeVar = makeVar<ViewMode>(VIEW_LESSONS);
const isEditingVar = makeVar<boolean>(false);

export function setViewMode(mode: ViewMode) {
  viewModeVar(mode);
}

export function getViewMode() {
  return viewModeVar();
}

export function setIsEditing(isEditing: boolean) {
  isEditingVar(isEditing);
}

export function getIsEditing() {
  return isEditingVar();
}
